import { useDispatch } from 'react-redux';
import { ChevronRightIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import {
  setSelectedTab,
  setSelectedTool,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import {
  AIR_AMBULANCE_TOOL,
  TOOLS_TAB,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import {
  BannerWrapper,
  IconWrapper,
  IconWrapperChevron,
} from '../Banner/StatusBanner.styles';
import StatusDisplay from './StatusDisplay';
import { useExistingRequest } from './hooks/useExistingRequest';
import { getStatusState } from './statusUtils';

interface StatusBannerProps {
  showChevron?: boolean;
}

const StatusBanner = ({
  showChevron = false,
}: StatusBannerProps): JSX.Element => {
  const dispatch = useDispatch();
  const { latestStatus, latestEta, existingRequest } = useExistingRequest();
  const existingRequestBody = existingRequest?.body;
  const isTimeout = existingRequest?.status === '408';

  const statuses = Array.isArray(existingRequestBody?.status)
    ? existingRequestBody.status
    : [];

  const statusState = getStatusState(
    existingRequestBody?.trip_data,
    statuses,
    isTimeout,
  );

  const handleClick = (): void => {
    dispatch(setSelectedTab(TOOLS_TAB));
    dispatch(setSelectedTool({ tool: AIR_AMBULANCE_TOOL }));
  };

  const IconComponent = statusState.icon;

  return (
    <BannerWrapper bgColor={statusState.bgColor} horizontal>
      <IconWrapper>
        <IconComponent color="background" height={16} width={16} />
      </IconWrapper>
      <Text color="background" ml="12px" size="normal">
        <StatusDisplay
          latestStatus={latestStatus}
          latestEta={latestEta}
          isTimeout={isTimeout}
        />
      </Text>
      {showChevron && (
        <IconWrapperChevron onClick={handleClick}>
          <ChevronRightIcon
            height={10}
            width={10}
            viewboxWidth={16}
            viewboxHeight={16}
            data-name="ambulance-banner-chevron"
          />
        </IconWrapperChevron>
      )}
    </BannerWrapper>
  );
};

export default StatusBanner;
